/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import PatientsidPatient from './PatientsidPatient';

/**
 * The PatientsIdBody model module.
 * @module model/PatientsIdBody
 * @version v0.3
 */
export default class PatientsIdBody {
  /**
   * Constructs a new <code>PatientsIdBody</code>.
   * @alias module:model/PatientsIdBody
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>PatientsIdBody</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/PatientsIdBody} obj Optional instance to populate.
   * @return {module:model/PatientsIdBody} The populated <code>PatientsIdBody</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new PatientsIdBody();
      if (data.hasOwnProperty('patient'))
        obj.patient = PatientsidPatient.constructFromObject(data['patient']);
    }
    return obj;
  }
}

/**
 * @member {module:model/PatientsidPatient} patient
 */
PatientsIdBody.prototype.patient = undefined;

